var CookieUtils;
((CookieUtils2) => {
  CookieUtils2.names = (doc = document) => {
    const ar = doc.cookie.split("; ");
    const names2 = [];
    for (let i = 0; i < ar.length; i++) {
      const c = ar[i];
      const nv = c.split("=");
      names2.push(nv[0]);
    }
    return names2;
  };
  CookieUtils2.get = (name, doc = document) => {
    const ar = doc.cookie.split("; ");
    for (let i = 0; i < ar.length; i++) {
      const c = ar[i];
      const nv = c.split("=");
      if (nv[0] == name) return decodeURIComponent(nv[1]);
    }
    return null;
  };
  CookieUtils2.make = (name, value, option) => {
    const cookieStr = name + "=" + (value ? encodeURIComponent(value) : "") + (option?.path ? `; path=${option?.path}` : "") + (option?.expireSecond !== void 0 ? "; expires=" + (() => {
      if (option.expireSecond !== null) {
        const expireDate = /* @__PURE__ */ new Date();
        expireDate.setTime(expireDate.getTime() + option.expireSecond * 1e3);
        return expireDate.toUTCString();
      } else {
        return (/* @__PURE__ */ new Date(0)).toUTCString();
      }
    })() : "") + (option?.domain ? `; Domain=${option?.domain}` : "") + (option?.maxAge ? `; Max-Age=${option?.maxAge}` : "") + (option?.secure ? "; Secure" : "") + (option?.httpOnly ? "; HttpOnly" : "") + (option?.sameSite ? `; SameSite=${option.sameSite}` : "");
    return cookieStr;
  };
  CookieUtils2.set = (name, value, option, doc = document) => {
    const cookieStr = CookieUtils2.make(name, value, option);
    doc.cookie = cookieStr;
  };
  CookieUtils2.remove = (name, option, doc = document) => {
    CookieUtils2.set(name, null, { ...option, expireSecond: null }, doc);
  };
})(CookieUtils || (CookieUtils = {}));
export {
  CookieUtils
};
//# sourceMappingURL=CookieUtils.js.map
